import type { MappableLedgerAccount } from './xeroLedgerAccountMappings.types'

export const MAPPABLE_LEDGER_ACCOUNTS: MappableLedgerAccount[] = [
  'DEFERRED_REVENUE',
  'RECOGNIZED_REVENUE',
  'UNBILLED_REVENUE',
  'CLEARING'
]

export const MAPPABLE_LEDGER_ACCOUNT_LABELS: Record<
  MappableLedgerAccount,
  string
> = {
  DEFERRED_REVENUE: 'Deferred revenue',
  RECOGNIZED_REVENUE: 'Recognized revenue',
  UNBILLED_REVENUE: 'Unbilled revenue',
  CLEARING: 'Clearing'
}

export const MAPPABLE_LEDGER_ACCOUNT_SECTION: Record<
  MappableLedgerAccount,
  { title: string; footer: string }
> = {
  DEFERRED_REVENUE: {
    title: 'Deferred revenue accounts',
    footer: 'Map Xero accounts for deferred revenue journal entries'
  },
  RECOGNIZED_REVENUE: {
    title: 'Recognized revenue accounts',
    footer: 'Map Xero accounts for recognized revenue journal entries'
  },
  UNBILLED_REVENUE: {
    title: 'Unbilled revenue accounts',
    footer: 'Map Xero accounts for unbilled revenue journal entries'
  },
  CLEARING: {
    title: 'Clearing account',
    footer: 'Map Xero accounts for clearing journal entries'
  }
}
